import { defineStore } from 'pinia'

export const useLoadingStore = defineStore({
  id: 'loading',
  state: () => ({
    activitiesDataLoading: false,
    countriesDataLoading: false,
    documentsDataLoading: false,
    financingDataLoading: false,
    imagesDataLoading: false,
    locationDataLoading: false,
    macrodataLoading: false,
    resultsDataLoading: false,
    sectorsDataLoading: false,
    statsDataLoading: false,
    themesDataLoading: false,
    videosDataLoading: false
  }),
  actions: {
    setLoading (variable, value) {
      this[variable] = value
    }
  }
})
